import { axiosInstance } from "../network";
import { API_URL } from "../../constants";

export default {
  getActiveSubscription: (uuid, page, pageSize, status) => {
    return axiosInstance.get(`${API_URL.GET_ACTIVE_SUBSCRIPTION}/${uuid}`, {
      params: {
        page: page + 1,
        pageSize: pageSize,
        subscription_status: status,
      },
    });
  },
  getRoleActivity: (uuid, page, pageSize) => {
    return axiosInstance.get(`${API_URL.GET_ROLE_ACTIVITY}/${uuid}`, {
      params: {
        page: page + 1,
        pageSize: pageSize,
      },
    });
  },
  getExpiredProducts: (page, pageSize) => {
    return axiosInstance.get(API_URL.GET_EXPIRED_PRODUCTS, {
      params: {
        page: page + 1,
        pageSize: pageSize,
      },
    });
  },
};
